import { useMutation, gql } from "@apollo/client";

const COMPLETE_PASSWORD_RESET = gql`
  mutation CompletePasswordReset($email: String!, $code: String!, $newPassword: String!) {
    completePasswordReset(email: $email, code: $code, newPassword: $newPassword)
  }
`;

export const useCompletePasswordResetMutation = () => {
  const [completePasswordReset, { loading, error }] = useMutation(COMPLETE_PASSWORD_RESET, {
    onError: (error) => {
      console.error("Error completing password reset:", error.message);
    },
  });

  const handleCompletePasswordReset = async (email: string, code: string, newPassword: string) => {
    try {
      const result = await completePasswordReset({
        variables: { email, code, newPassword },
      });
      return { success: result.data?.completePasswordReset ?? false };
    } catch (error: any) {
      console.error("Error occurred during password reset completion:", error);
      return { 
        success: false, 
        error: error?.message || "Failed to reset password. Please try again." 
      };
    }
  };

  return {
    handleCompletePasswordReset,
    loading,
    error,
  };
};




















